export enum MenuView {
  icons = 'icons',
  iconsAndText = 'iconsAndText',
  text = 'text'
}
